var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSns1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1575 -3569)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 81",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1575 3569)",
    style: {
      fill: "#303542"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 23",
    d: "M12.007 17a50.687 50.687 0 0 0 8.081-.461 3.129 3.129 0 0 0 2.039-1.6A15.831 15.831 0 0 0 23 9a15.838 15.838 0 0 0-.872-5.944 3.131 3.131 0 0 0-2.039-1.594A50.687 50.687 0 0 0 12.007 1h-.016a50.687 50.687 0 0 0-8.081.461 3.129 3.129 0 0 0-2.038 1.595A15.85 15.85 0 0 0 1 9a15.843 15.843 0 0 0 .872 5.943 3.128 3.128 0 0 0 2.039 1.6 50.687 50.687 0 0 0 8.081.457z",
    transform: "translate(1583 3580)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 24",
    d: "M23 19.814V12l6.83 3.721z",
    transform: "translate(1569.348 3573.093)",
    style: {
      fill: "#303542"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSns1);
export default __webpack_public_path__ + "static/media/sns_1.b0b01bb5ed6ecab9d6e4dfbeb7c08447.svg";
export { ForwardRef as ReactComponent };